<template>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="canNotLoadMore" infinite-scroll-distance="10" infinite-scroll-immediate-check="false" style="-webkit-user-drag: none;">
        <list-item v-for="order in debtOrders" :key="order.id" :order="order"/>
        <list-item v-for="order in orders" :key="order.id" :order="order"/>
        <div class="empty" v-if="isEmpty">
            <div class="img">
                <img src="@/assets/img/list.png">
            </div>
            <div class="title">
                目前沒有任務
            </div>
            <router-link class="button" :to="{name: 'home'}">
                前往首頁下訂單
            </router-link>
        </div>
    </div>
</template>

<script>
    import ListItem from './ListItem';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'ProcessingOrders',
        components: {
            'list-item': ListItem,
        },
        data() {
            return {
                loading: false,
            }
        },
        computed: {
            isEmpty() {
                return this.processing.length === 0;
            },
            canNotLoadMore() {
                return !(this.processingMeta.total && this.processingMeta.current_page < this.processingMeta.last_page && !this.loading);
            },
            debtOrders() {
                return this.processing.filter(order => order.is_debt);
            },
            orders() {
                return this.processing.filter(order => ! order.is_debt);
            },
            ...mapGetters(['processing', 'processingMeta'])
        },
        methods: {
            loadMore() {
                this.loading = true;
                this.loadMoreProcessingOrders({}).then(() => {
                    this.loading = false;
                });
            },
            ...mapActions(['getProcessingOrders', 'loadMoreProcessingOrders'])
        },
        created() {
            this.getProcessingOrders({});
        }
    };
</script>

<style lang="scss" scoped>
    .empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 120px;

        img {
            width: 50px;
            height: 50px;
        }

        .title {
            margin-top: 30px;
            color: #4A4A4A;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
        }

        .button {
            margin: 30px auto;
            padding: 5px 10px;
            border-radius: 13px;
            background-color: #339933;
            color: #FFFFFF;
            font-size: 12px;
            line-height: 17px;
            text-align: center;
            text-decoration: none;
        }
    }
</style>
